import { buildHttpGet } from "./backendInterface.js";


function getCompanies(onReady, accessToken) {
    let requestParams = new Map();
    requestParams.set("accessToken", accessToken);

    function alertContents(httpRequest) {
        if (httpRequest && httpRequest.readyState === XMLHttpRequest.DONE) {
            console.log("httpRequest.status: " + httpRequest.status);
            if (httpRequest.status === 200) {
                console.log("Get companies success");
                console.log("Body: " + httpRequest.responseText);
                onReady(JSON.parse(httpRequest.responseText));
            } else if (httpRequest.status === 403) {
                console.log("Login denied. Status: " + httpRequest.status + " Error: " + httpRequest.thrownError);
                alert('Failed to get companies');
            } else if (httpRequest.status === 409) {
                console.log("User not activated. Status: " + httpRequest.status + " Error: " + httpRequest.thrownError);
                alert('User not activated');
            } else {
                alert("There was a problem with the request: ", httpRequest.status);
            }
        }
    }

    let httpRequest = buildHttpGet("companies", requestParams, alertContents);
    httpRequest.sendRequest();
}

function getCompany(onReady, accessToken, companyId) {
    let requestParams = new Map();
    requestParams.set("accessToken", accessToken);

    function alertContents(httpRequest) {
        if (httpRequest && httpRequest.readyState === XMLHttpRequest.DONE) {
            console.log("httpRequest.status: " + httpRequest.status);
            if (httpRequest.status === 200) {
                console.log("Get company success");
                console.log("Body: " + httpRequest.responseText);
                onReady(JSON.parse(httpRequest.responseText));
            } else if (httpRequest.status === 403) {
                console.log("Login denied. Status: " + httpRequest.status + " Error: " + httpRequest.thrownError);
                alert('Failed to get companies');
            } else if (httpRequest.status === 409) {
                console.log("User not activated. Status: " + httpRequest.status + " Error: " + httpRequest.thrownError);
                alert('User not activated');
            } else {
                alert("There was a problem with the request: ", httpRequest.status);
            }
        }
    }

    let httpRequest = buildHttpGet("companies/" + companyId, requestParams, alertContents);
    httpRequest.sendRequest();
}

export { getCompanies, getCompany };
